import styled from "styled-components";

// Tokens dos gráficos. O painel não tem tema escuro, então não há par dark.
// Série única = verde da marca (o mesmo dos gráficos antigos). Divisão por papel
// = três primeiras posições da paleta categórica validada (azul, laranja, água):
// ΔE de daltonismo >= 9 entre todos os pares. O verde-água tem contraste < 3:1
// com o fundo claro, então os valores SEMPRE aparecem também na tabela e na
// legenda (regra de relevo da paleta).
export const COR_SERIE = "#2AA444";
export const COR_PAPEL = { Comum: "#2a78d6", Profissional: "#eb6834", Administrador: "#1baf7a" };
export const COR_TEXTO = "#4D4F50";
export const COR_GRADE = "#EFF0F2";
export const COR_SUPERFICIE = "#FEFEFE";

export const Secao = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
  border-radius: 8px;
  border: 1.5px solid ${COR_GRADE};
  background: ${COR_SUPERFICIE};
  padding: 20px;

  h3{ margin: 0; font-size: 16px; font-weight: 700; }
  .sub{ margin: 2px 0 0; font-size: 12px; color: ${COR_TEXTO}; }

  .totais{
    display: flex;
    flex-wrap: wrap;
    gap: 6px 20px;
    font-size: 13px;
    color: ${COR_TEXTO};
    strong{ color: #111; font-size: 15px; }
  }

  .erro{ color: #C43333; font-size: 13px; }

  /* Cabeçalho de bloco com ação à direita (ex.: "Ver todos"). */
  .cabecalho-bloco{
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
  }
  .ver-todos{ font-size: 12px; font-weight: 600; color: var(--primary-color); }

  /* Células de tabela (TabelaAdmin) dentro dos relatórios. */
  .direita{ font-variant-numeric: tabular-nums; }
  .rotulo-linha{ font-size: 13px; overflow-wrap: anywhere; }
  .rotulo-linha small{ margin-left: 6px; font-size: 11px; color: ${COR_TEXTO}; font-weight: 400; }
  .vazio{ padding: 28px 0; text-align: center; font-size: 13px; color: ${COR_TEXTO}; }
  .carregando{ padding: 28px 0; text-align: center; font-size: 13px; color: ${COR_TEXTO}; }
`;

export const Filtros = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: flex-end;

  .campo{
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 130px;

    label{ font-size: 11px; font-weight: 700; color: ${COR_TEXTO}; margin: 0; }

    select, input{
      height: 34px;
      margin: 0;
      padding: 0 8px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 13px;
      background: #fff;
    }
  }

  .segmentado{
    display: inline-flex;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;

    button{
      height: 34px;
      width: auto;
      margin: 0 !important;
      padding: 0 12px;
      border: none;
      border-radius: 0;
      font-size: 13px;
      cursor: pointer;
      background: #fff;
      color: ${COR_TEXTO};

      & + button{ border-left: 1px solid #ccc; }
      &[aria-pressed="true"]{ background: var(--primary-color); color: #fff; }
      &:disabled{ cursor: not-allowed; opacity: .5; }
    }
  }

  .limpar{
    height: 34px;
    width: auto;
    margin: 0 !important;
    padding: 0 12px;
    font-size: 12px;
    border-radius: 8px;
    cursor: pointer;
    background: transparent;
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
  }

  .dica{ font-size: 11px; color: ${COR_TEXTO}; flex-basis: 100%; }
  .aviso{ font-size: 12px; color: #C43333; flex-basis: 100%; }
`;

export const Tabela = styled.div`
  max-height: 320px;
  overflow: auto;
  border: 1px solid ${COR_GRADE};
  border-radius: 8px;

  table{ width: 100%; border-collapse: collapse; font-size: 13px; }
  caption{ text-align: left; padding: 8px 10px; font-size: 12px; font-weight: 700; color: ${COR_TEXTO}; }
  th, td{ padding: 7px 10px; border-top: 1px solid ${COR_GRADE}; }
  th{ position: sticky; top: 0; background: #F7F8F9; text-align: left; font-size: 12px; color: ${COR_TEXTO}; }
  th.num, td.num{ text-align: right; font-variant-numeric: tabular-nums; }
  th small, td small{ color: ${COR_TEXTO}; margin-left: 6px; font-weight: 400; font-size: 11px; }
`;

export const Kpis = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;

  .grupo h3{ margin: 0 0 8px; font-size: 14px; font-weight: 700; color: ${COR_TEXTO}; }

  .grade{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }

  .kpi{
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 14px 16px;
    border-radius: 8px;
    border: 1.5px solid ${COR_GRADE};
    background: ${COR_SUPERFICIE};

    .valor{ font-size: 26px; font-weight: 700; line-height: 1.1; font-variant-numeric: tabular-nums; }
    .rotulo{ font-size: 12px; font-weight: 600; color: ${COR_TEXTO}; }
    .detalhe{ font-size: 11px; color: ${COR_TEXTO}; }

    &.atencao{ border-color: #F0DBA8; background: #FFFBF1; }
  }

  .erro{ color: #C43333; font-size: 13px; }
`;
